var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chart"},[(_vm.chartData)?_c('chart-line',{attrs:{"height":250,"chart-options":_vm.chartOptions,"chart-data":_vm.chartData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }